export default "__VITE_ASSET__vQDU8ZGM__"